import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { StepContainer } from '../../components/StepContainer/StepContainer';
import { StepFooter } from '../../components/StepFooter/StepFooter';
import { useCharitableGivingContext } from '../../context/useCharitableGivingContext';
import { FormValues, STEP_ID } from './DafGrantAmount.meta';
import { INPUTS_WIDTH } from '../../CharitableGiving.meta';
import { useNavigation } from '../../hooks/useNavigation';
import { InputNumberMask } from '../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { WorkflowDTO } from '../../api/useCharitableGivingQuery';

export const DafGrantAmount = () => {
  const { workflow, setWorkflow, setStep } = useCharitableGivingContext();

  const { progress, previousStep, nextStep, isFirstStep } = useNavigation({ currentStep: STEP_ID });

  const { control, handleSubmit } = useForm<FormValues>({
    defaultValues: {
      dafGrantAmount: workflow.data.dafGrantAmount,
    },
  });

  const onSubmit = handleSubmit(values => {
    const newWorkflow: WorkflowDTO = {
      ...workflow,
      data: {
        ...workflow.data,
        dafGrantAmount: values.dafGrantAmount,
      },
    };

    setWorkflow(newWorkflow);

    if (nextStep) {
      setStep(nextStep);
    }
  });

  return (
    <StepContainer
      title="How much would you like to grant?"
      onSubmit={onSubmit}
      footer={
        <StepFooter
          isFirstStep={isFirstStep}
          progress={progress}
          onPrevious={previousStep ? () => setStep(previousStep) : undefined}
        />
      }
    >
      <Controller
        control={control}
        name="dafGrantAmount"
        render={({ field: { value, onChange, ref } }) => (
          <Box width={INPUTS_WIDTH}>
            <InputNumberMask
              ref={ref}
              label={
                <Box display="flex" alignItems="baseline" style={{ gap: 4 }}>
                  <Text as="span" variant="formLabel">
                    Grant Amount
                  </Text>
                  <Text as="span" fontSize="small" color="neutral.500">
                    (Optional)
                  </Text>
                </Box>
              }
              leftIcon="fa fa-dollar-sign"
              innerText="/annually"
              value={value ?? ''}
              allowNegative={false}
              onValueChange={({ floatValue }) => onChange(floatValue ?? null)}
            />
          </Box>
        )}
      />
    </StepContainer>
  );
};
